import React from 'react';
import styled from '@emotion/styled';

import { mediaQuery } from '@modernhealth/vital-foundation';
import { HeadingText50, pxToRem } from '@modernhealth/vital-components';
interface OuterWrapperProps {
    scrollContent?: boolean;
}

const OuterWrapper = styled.div<OuterWrapperProps>(({ scrollContent }) => ({
    maxWidth: pxToRem(700),
    width: '100%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: scrollContent ? pxToRem(20) : 0,
}));

const InnerWrapper = styled.div({
    maxWidth: pxToRem(500),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',

    paddingBottom: pxToRem(30),
    [mediaQuery.maxHeight('sm')]: {
        marginTop: 0,
    },
});
interface Props {
    scrollContent?: boolean;

    title?: string;
}

export const QuestionWrapper: React.FC<Props> = ({
    scrollContent,
    title = 'testing',
    children,
}) => (
    <OuterWrapper scrollContent={scrollContent}>
        <HeadingText50 marginBottom={32} centered>
            {title}
        </HeadingText50>
        <InnerWrapper>{children}</InnerWrapper>
    </OuterWrapper>
);
